<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Ver Cálculos Administrativos Folio:{{ folio }}
            <div>
              <BackButton :to="{ name: 'CalculoAdministrativo' }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </BackButton>
            </div>
          </CCardHeader>

          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CCol sm="12" class="text-right">
              {{ this.item.author ? this.item.author.correo : "" }}
            </CCol>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  v-model="fechahora"
                  disabled
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Trabajador:</label>
                <CInput v-model="trabajador" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Empresa:</label>
                <CInput v-model="empresa" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol class="inventario-panel">
                <SimpleTableCalculoAdministrativo
                  v-for="(row, i) in documentos_relacionados_"
                  :key="`table_${i}`"
                  :row="row"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import moment from "moment";
import SimpleTableCalculoAdministrativo from "./SimpleTableCalculoAdministrativo.vue";
import "vue-select/dist/vue-select.css";
import DocsTranslationMixin from "@/mixins/DocsTranslationMixin";

export default {
  name: "VerAsistencia",
  mixins: [DocsTranslationMixin],
  components: {
    SimpleTableCalculoAdministrativo
  },
  data() {
    return {
      folio: this.$route.params.id,

      fechahora: "",
      isLoading: false,
      isLoadingPage: false,
      documentos_relacionados: [],
      trabajador: null,
      empresa: null,
      successModal: false,
      warningModal: false,
      nanoid: undefined,
      error: "",

      item: {},
    };
  },
  created() {
    this.isLoadingPage = true;
    this.isLoading = true;

    const ubi = [
      this.$store.dispatch("customDocumentoHTTP", {
        schema: "calculos_administrativos",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"]: ["*"]
      })
    ];

    // ubi.push(ubicacionTemplateNoRaiz);

    Promise.all(ubi)
      .then(([item]) => {
        this.item = item.data[0];
        this.documentos_relacionados = this.relacionesByNomina(this.item.payload.encabezado._relaciones);

        this.trabajador = this.item.payload.encabezado._relaciones.trabajador.payload.nombre;
        this.empresa = this.item.payload.encabezado._relaciones.empresa.payload.nombre;
        this.fechahora = moment(
          this.item.payload.encabezado.fechahora,
          "YYYY-MM-DD HH:mm:ss"
        ).format("YYYY-MM-DD");
      })
      .finally(() => (this.isLoading = false));
  },
  computed: {
    documentos_relacionados_() {
      return this.documentosRelacionados(this.documentos_relacionados)
    },
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.inventario-panel-row {
  margin-bottom: 10px;
  h4.inventario-panel-subtitle {
    width: 100%;
  }
  section {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 10px;
  }
}
.catalogo-text {
  font-size: 1.2rem !important;
}
</style>
